import React from "react";
import { LogOut, LayoutDashboard } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Header = ({ onLoginClick }) => {
	const { currentUser, logout } = useAuth();
	const navigate = useNavigate();

	return (
		<header className="bg-black/95 backdrop-blur-sm border-b border-gray-800 sticky top-0 z-50">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
				<div className="flex justify-between items-center">
					{/* Brand/Logo - Left */}
					<div className="flex items-center">
						<a
							href="/"
							className="flex items-center space-x-2 sm:space-x-3 text-lg sm:text-xl font-bold text-white tracking-wide hover:text-orange-400 transition-colors duration-200 cursor-pointer"
						>
							<img
								src="/JDIconAsset 1.png"
								alt="James Dixon Logo"
								className="w-7 h-7 sm:w-8 sm:h-8 object-contain"
							/>
							<span className="hidden xs:block sm:block">James Dixon</span>
						</a>
					</div>

					{/* Navigation - Center */}
					<nav className="hidden md:flex space-x-8">
						<a
							href="/projects"
							className="text-gray-300 hover:text-white transition-colors duration-200 font-medium"
						>
							Projects
						</a>
						<a
							href="/about"
							className="text-gray-300 hover:text-white transition-colors duration-200 font-medium"
						>
							About Me
						</a>
					</nav>

					{/* User Menu - Right */}
					<div className="flex items-center space-x-2 sm:space-x-4">
						{currentUser ? (
							<div className="flex items-center space-x-2 sm:space-x-3">
								<span className="text-xs sm:text-sm text-gray-300 hidden sm:block">
									{currentUser.name}
								</span>
								<button
									onClick={() => navigate("/dashboard")}
									className="p-2 text-gray-400 hover:text-white transition-colors"
									title="Dashboard"
								>
									<LayoutDashboard className="w-4 h-4 sm:w-5 sm:h-5" />
								</button>
								<button
									onClick={logout}
									className="p-2 text-gray-400 hover:text-red-400 transition-colors"
									title="Logout"
								>
									<LogOut className="w-4 h-4 sm:w-5 sm:h-5" />
								</button>
							</div>
						) : (
							<button
								onClick={onLoginClick}
								className="px-4 sm:px-6 py-2 bg-gradient-to-r from-orange-700 to-orange-500 text-white rounded-full hover:from-orange-800 hover:to-orange-600 transition-all duration-200 font-medium text-sm sm:text-base"
							>
								Log in
							</button>
						)}
					</div>
				</div>
			</div>
		</header>
	);
};

export default Header;
